import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { DoughnutChart } from '../../../../app/models/charts';

type Props = {
  data: DoughnutChart;
  width?:number;
  height?:number;
}

ChartJS.register(ArcElement, Tooltip, Legend);

const KoReportingChart: React.FC<Props> = ({ data, width=400, height=400 }) => {
  return <Pie
    data={data}
    height={height}
    width={width}
  />;
}
export default KoReportingChart;
